import { AuthenticationCtx } from 'components/providers/AuthCtx';
import { Message } from 'data/message';
import { PartOrder } from 'data/part_order';
import { PartOrderForm, partOrderFormToBody } from 'data/part_order_form';
import { post, api, get, put, del } from './api';

const endpoint = "part-order";

export const getAllPartOrders = (authCtx: AuthenticationCtx): Promise<PartOrder[]> => {
    return get<PartOrder[]>({
        url: `${api}/${endpoint}`,
        authCtx,
    }).then(res => res.data);
}

export const getPartOrder = (authCtx: AuthenticationCtx, id: string): Promise<PartOrder> => {
    return get<PartOrder>({
        url: `${api}/${endpoint}/${id}`,
        authCtx,
    }).then(res => res.data);
}

export const updatePartOrder = (authCtx: AuthenticationCtx, partOrder: PartOrderForm): Promise<Message> => {
    return put<Message>({
        url: `${api}/${endpoint}/${partOrder.id}`,
        authCtx,
    }, partOrderFormToBody(partOrder)).then(res => res.data);
}

export const createPartOrder = (authCtx: AuthenticationCtx, partOrder: PartOrderForm): Promise<Message> => {
    return post<Message>({
        url: `${api}/${endpoint}`,
        authCtx,
    }, partOrderFormToBody(partOrder)).then(res => res.data);
}

export const deletePartOrder = (authCtx: AuthenticationCtx, partOrder: PartOrder): Promise<Message> => {
    return del<Message>({
        url: `${api}/${endpoint}/${partOrder.id}`,
        authCtx,
    }).then(res => res.data);
}
